<script>
  export let title = '';
  export let description = '';
  export let eyebrow = '';
  export let className = '';
  export let bodyClass = 'p-5 sm:p-6';
</script>

<section class={`min-w-0 rounded-xl border border-slate-200 bg-white shadow-sm ${className}`}>
  {#if title || description || eyebrow || $$slots.actions}
    <header class="flex flex-col gap-4 border-b border-slate-200 px-5 py-4 sm:flex-row sm:items-start sm:justify-between sm:px-6">
      <div class="min-w-0">
        {#if eyebrow}
          <p class="text-xs font-semibold uppercase text-slate-500">{eyebrow}</p>
        {/if}

        {#if title}
          <h2 class="text-base font-semibold text-slate-900">{title}</h2>
        {/if}

        {#if description}
          <p class="mt-1 text-sm text-slate-500">{description}</p>
        {/if}
      </div>

      {#if $$slots.actions}
        <div class="shrink-0">
          <slot name="actions" />
        </div>
      {/if}
    </header>
  {/if}

  <div class={bodyClass}>
    <slot />
  </div>
</section>
